import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './6e45c1cc67e4082bfa63857d1d15e89ae0fd1b76e295870e98930b3292e8ff1c.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useClickOutsidePortals from '../../hooks/useClickOutsidePortals/45d712ecd01671ec043f2a5dbb4411360af5746ce8ef0a7533c54622d3ae438a.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import Popper from '../../utils/Popper/53f589867426c0fe9404d76ffe1e6e0db92964f6396b0b62988d89a525e5a08b.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["show", "onClose", "content", "placement", "children", "zIndex", "className", "portalTarget", "isArrowRemoved", "onClickOutside", "onClick", "onKeyDown", "style", "id"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var Popover = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    onClose = _ref.onClose,
    content = _ref.content,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    children = _ref.children,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
    className = _ref.className,
    portalTarget = _ref.portalTarget,
    _ref$isArrowRemoved = _ref.isArrowRemoved,
    isArrowRemoved = _ref$isArrowRemoved === void 0 ? false : _ref$isArrowRemoved,
    onClickOutside = _ref.onClickOutside,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    externalId = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames(styles.popover, className);
  var anchorRef = useRef();
  var popperRef = useRef(null);
  var preventClickOutside = useClickOutsidePortals(function (e) {
    return show && (onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside(e));
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInDOM = _useState2[0],
    setIsInDOM = _useState2[1];
  var popoverId = useId(externalId);

  // Focus lock can't be enabled without `onClose` function because keyboard users need a way to exit the focus lock
  var isFocusLockEnabled = typeof onClose === 'function';
  useEffect(function () {
    /*
     * Only focuses the anchor element if the `show` prop is false and the `isInDom` prop is still true.
     * This indicates that the state moved from show to hide.
     * We don't want to focus the anchor element on mount because that will mess up focus management, which is why we are explicitely doing a show-to-hide check.
     * `react-focus-lock` handles this logic with the `returnFocus` prop, but it doesn't always work.
     * `returnFocus` doesn't work when:
     * 1. A user in Chrome clicks on 2 or more `Popover` anchor elements and then presses the `Escape` key. Even though buttons are focused on `mousedown` in Chrome by default, the previously opened `Popover` grabs focus right after the next anchor element is clicked, and therfore the previously opened `Popover` becomes the place to return focus, which is not what we want.
     * 2. A user in Safari clicks on 1 or more `Popover` anchor elements and then presses the `Escape` key. This is because buttons aren't focused on `click` or `mousedown` in Safari by default.
     */
    if (!show && isInDOM) {
      var _anchorRef$current;
      // Prevents scroll so that the page does not scroll to the anchor element if the anchor element is out of view
      (_anchorRef$current = anchorRef.current) === null || _anchorRef$current === void 0 || _anchorRef$current.focus({
        preventScroll: true
      });
    }
    setIsInDOM(show);
  }, [show, isInDOM]);
  var handlePopoverContainerClick = function handlePopoverContainerClick(e) {
    onClick === null || onClick === void 0 || onClick(e);
  };
  var handlePopoverContainerKeyDown = function handlePopoverContainerKeyDown(e) {
    if (e.key === 'Escape') {
      e.stopPropagation(); // prevent event from closing modals or popovers
      onClose === null || onClose === void 0 || onClose(e);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  return /*#__PURE__*/React__default.createElement(Popper, {
    open: show,
    isFocusLocked: true,
    focusLockProps: {
      disabled: !isFocusLockEnabled
    },
    placement: placement,
    anchor: /*#__PURE__*/React__default.cloneElement(children, {
      'aria-expanded': show,
      'aria-controls': show ? popoverId : undefined,
      'aria-haspopup': 'dialog',
      onClick: function onClick(e) {
        var _children$props, _children$props$onCli;
        // NOTE: In IE11, an `onClick` event on the anchor element focuses the anchor. `e.preventDefault()` does not prevent focus `onClick`, so this is a known regression with no known fix.
        children === null || children === void 0 || (_children$props = children.props) === null || _children$props === void 0 || (_children$props$onCli = _children$props.onClick) === null || _children$props$onCli === void 0 || _children$props$onCli.call(_children$props, e);
      },
      onMouseDown: function onMouseDown(e) {
        var _children$props$onMou, _children$props2;
        /*
         * Prevents the anchor element from getting focus (only in some browsers).
         * If a Popover is open and out of view, and another button is clicked, this prevents the browser from scrolling to the open Popover.
         * TODO: Pull in feature (if/when available) from `react-focus-lock` that prevents scroll whenever `react-focus-lock` calls `focus()`. `e.preventDefault()` can then be removed.
         */
        e.preventDefault();
        preventClickOutside();
        (_children$props$onMou = (_children$props2 = children.props).onMouseDown) === null || _children$props$onMou === void 0 || _children$props$onMou.call(_children$props2, e);
      },
      ref: mergeRefs(anchorRef, children === null || children === void 0 ? void 0 : children.ref)
    }),
    popper: /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
      ref: mergeRefs(ref, popperRef),
      style: _objectSpread({
        zIndex: zIndex
      }, style),
      className: classes,
      onMouseDown: preventClickOutside,
      onClick: handlePopoverContainerClick,
      onKeyDown: handlePopoverContainerKeyDown,
      id: popoverId,
      role: "dialog",
      tabIndex: 0 // Allows focus lock to lock focus in the Popover content even when there are no interactive elements
      ,
      "aria-modal": isFocusLockEnabled ? 'true' : undefined
    }), content),
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 7]
      }
    }],
    arrow: isArrowRemoved ? undefined : /*#__PURE__*/React__default.createElement("div", {
      className: styles.arrow
    }, /*#__PURE__*/React__default.createElement("div", null)),
    portalTarget: portalTarget
  });
});

export { Popover as default };
